module.exports = __webpack_public_path__ + "static/media/activity.181942ea.svg";